/*
 * "On this page" rail scroll-spy + FAQ deep links.
 *
 * 1. Rail scroll-spy: highlights the section the reader is in, mirroring the
 *    content-pages scrollspy (IntersectionObserver over the section anchors).
 *    Every server-rendered rail opts in with the same [data-toc-spy] hook - the
 *    FAQ and the product Features / Screenshots tabs - so the active state
 *    behaves identically across them.
 * 2. Deep links: a #<question-slug> in the URL (from search results, the sitemap
 *    or a shared link) opens that Bootstrap accordion item so the answer is
 *    visible on arrival; base.html already handles the sticky-offset scroll.
 *
 * No-op on pages without a rail / .faq-acc accordion.
 */
(function () {
    var toc = document.querySelector('[data-toc-spy]');
    if (toc) {
        var nav = toc.querySelector('.content-toc');
        var links = nav ? Array.prototype.slice.call(nav.querySelectorAll('a')) : [];
        var sections = links
            .map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); })
            .filter(Boolean);
        if (sections.length) {
            var spy = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    links.forEach(function (link) {
                        link.classList.toggle('active', link.getAttribute('href') === '#' + entry.target.id);
                    });
                });
            }, {rootMargin: '-110px 0px -70% 0px'});
            sections.forEach(function (s) { spy.observe(s); });
        }
    }

    // Open the accordion item the URL points at (raw question slug as the item id).
    function openHash() {
        if (!location.hash) return;
        var item;
        try {
            item = document.getElementById(decodeURIComponent(location.hash.slice(1)));
        } catch (e) {
            return;
        }
        if (!item || !item.classList.contains('accordion-item')) return;
        var collapse = item.querySelector('.accordion-collapse');
        var btn = item.querySelector('.accordion-button');
        if (collapse && !collapse.classList.contains('show')) {
            collapse.classList.add('show');
            if (btn) {
                btn.classList.remove('collapsed');
                btn.setAttribute('aria-expanded', 'true');
            }
        }
    }

    openHash();
    window.addEventListener('hashchange', openHash);
})();
